import { createNavigationContainerRef } from '@react-navigation/native';

const navigationRef = createNavigationContainerRef();

function getRoute() {
	if (navigationRef.isReady()) {
		return navigationRef.getCurrentRoute();
	}
}

export { navigationRef, getRoute };
